import { render, staticRenderFns } from "./placementTests.vue?vue&type=template&id=31e89fa2&"
import script from "./placementTests.vue?vue&type=script&lang=js&"
export * from "./placementTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports